import { sendEvent } from '@utils/core/track';
import generatePath from '@utils/generatePath';
import { ONE_ON_ONE } from 'constants/url';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './styles.scss';


const MapCoversSection: FC = () => {
	const { width } = useResizeObserver()
	const { transData } = useTranslation('home.mapCovers')

	return (
		<section className={styles['ac-map']}>
			<div className={styles['ac-map-container']}>
				<h1>{transData.title.h1} <span>{transData.title.span}</span></h1>
				<div className={styles['ac-map-img']}>
					{width < 768 ?
						<>
							<div className={styles.img}>
								<img loading='lazy' src={transData.mapImg} alt="" />
							</div>
							<div className={styles['linear']} />
						</> :
						<img loading='lazy' src={transData.mapImg} alt="" />
					}
				</div>
				<div className={styles['ac-map-btn']}>
					<NavLink to={generatePath(ONE_ON_ONE) + '#subject'} onClickCapture={() => {
						sendEvent({ eventId: 'ACW_home_cover70' });
					}}>
						<h4>{transData.h4}</h4>
					</NavLink>
					<img className={styles['map-icon']} loading='lazy' src="https://web-data.zmlearn.com/image/4xjMzkuuh54XWfJsjSTJV1/img_home_part4_gantan%402x.png" alt="" />
					<span className={styles['hand']}></span>
				</div>
			</div>
		</section>
	);
}

export default MapCoversSection
